CountDownTimer('07/03/2025 11:59 PM', 'msdwCountdown');

function CountDownTimer(dt, id) {
    var end = new Date(dt);

    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;
    var timer;

    function showRemaining() {
        var now = new Date();
        var distance = end - now;
        if (distance < 0) {
            clearInterval(timer);
            return;
        }
        var days = Math.floor(distance / _day);
        var hours = Math.floor((distance % _day) / _hour);
        var minutes = Math.floor((distance % _hour) / _minute);
        var seconds = Math.floor((distance % _minute) / _second);

        document.querySelector('.msdw-countdown-days span').innerHTML = days;
        document.querySelector('.msdw-countdown-hours span').innerHTML = hours;
        document.querySelector('.msdw-countdown-minutes span').innerHTML = minutes;
        // document.querySelector('.msdw-countdown-seconds span').innerHTML = seconds;
    }

    timer = setInterval(showRemaining, 1000);
}
